import CurrencyRate from 'components/CurrencyRate';
import { CalendarDay } from 'further-ui/utils';
import useCurrencyRate from 'hooks/lp/data/currencies/useCurrencyRate';
import { useFormContext } from 'react-hook-form';
import { revaluation as rules } from 'further-ui/validations';
import RevaluationForm from './index';

type RevaluationFormWithFxRateProps = Omit<
  React.ComponentProps<typeof RevaluationForm>,
  'fxRate' | 'rateSelector'
>;

const RevaluationFormWithFxRate: React.FC<RevaluationFormWithFxRateProps> = (
  props,
) => {
  const { watch, getValues, setValue } =
    useFormContext<rules.RevaluationFields>();

  const revaluationDate = watch('currentRevaluationDate');
  const currency = props.assetCurrency ?? props.vehicle.baseCurrency;

  const { fxRate, changeRate, isFetchingRate } = useCurrencyRate({
    vehicleId: props.vehicle._id,
    currency,
    date: new CalendarDay(revaluationDate ?? new Date()),
    defaultCurrencyRate: getValues('revaluationCurrencyRates.global') ?? null,
    onRateChange: (rate) => {
      setValue('revaluationCurrencyRates.global', rate ?? undefined);
    },
  });

  const rateSelector = (
    <CurrencyRate
      currency={currency}
      date={new CalendarDay(revaluationDate ?? new Date())}
      vehicle={props.vehicle}
      fxRate={fxRate}
      onRateChange={changeRate}
      isFetchingRate={isFetchingRate}
    />
  );

  return (
    <RevaluationForm {...props} fxRate={fxRate} rateSelector={rateSelector} />
  );
};

export default RevaluationFormWithFxRate;
